export const SLOGAN = "B for Big Savings!";
const B_TONES = { default: "text-[#E2A100]", light: "text-[#FFD23F]", onYellow: "text-[#B87F00]" };

export const Slogan = ({ tone = "default" }) => (
  <span aria-label={SLOGAN}><span className={B_TONES[tone]} aria-hidden="true">B</span><span aria-hidden="true"> for Big Savings!</span></span>
);
